const translateColumnConfig = (t, useAddressesWithLessFields) => {
  const idObject = {
    Header: 'ID',
    accessor: 'id',
    width: 100,
  };
  const cityObject = {
    Header: t('common.address.city'),
    accessor: 'city',
  };

  const postcodeObject = {
    Header: t('common.address.postCode'),
    accessor: 'postCode',
  };

  if (useAddressesWithLessFields) {
    return [
      idObject,
      cityObject,
      postcodeObject,
      {
        Header: t('clients.addressLine1'),
        accessor: 'addressLine1',
      },
      {
        Header: t('clients.addressLine2'),
        accessor: 'addressLine2',
      },
    ];
  }

  return [
    idObject,
    cityObject,
    {
      Header: t('common.address.street'),
      accessor: 'street',
    },
    {
      Header: t('common.address.buildingNo'),
      accessor: 'buildNumber',
    },
    {
      Header: t('common.address.localNo'),
      accessor: 'placeNumber',
    },
    postcodeObject,
    {
      Header: t('clients.zoneName'),
      accessor: 'zoneName',
    },
  ];
};

export default translateColumnConfig;
